var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernBridgeRoadSymbolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.138,
    height: 48.098,
    viewBox: "0 0 56.138 48.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modern-bridge-road-symbol",
    transform: "translate(0 -35.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11903",
    "data-name": "Path 11903",
    d: "M49.653,51.759c1.047-.423,2.109-.805,3.183-1.164L52.1,50.59h-.043q-1.392,0-2.779.079L44.4,36.426l-.331-.964-.482.9-9.391,17.57q-1.79.688-3.529,1.5L23.626,36.586l-.408-1.093L22.8,36.582,9.579,71.091q-1.442,1.534-2.808,3.138-2.043,2.407-3.9,4.967C1.864,80.6.886,82.03.017,83.525L0,83.56H10.6l2.313-4.406,3.054,0c-.948,1.867-1.625,3.423-2.027,4.4H25.609a50.905,50.905,0,0,1,4.051-12.546q.939-1.964,2.064-3.833L35.24,79.12h4.272L33.859,63.986a37.267,37.267,0,0,1,3.283-3.872,36.431,36.431,0,0,1,10.209-7.342l.149-.07,4.417,17.973h4.22ZM14.691,66.108,23.205,38.24l5.364,18.22q-.7.359-1.382.735a67.262,67.262,0,0,0-10.987,7.6Q15.436,65.441,14.691,66.108Zm4.321,7.7H16.13s2.559-3.452,3.879-5.067l2.643.01A53.139,53.139,0,0,0,19.011,73.812Zm8.008-9.656-2.709.015,5.367-4.035.439,1.581A31.581,31.581,0,0,0,27.019,64.157Zm7.168-5.393-1.355-.588,5-2.965,1.391.129A49.978,49.978,0,0,0,34.187,58.763Zm7.48-4.863-.987-.17A37.874,37.874,0,0,1,46.3,51.588l.283.055A31.475,31.475,0,0,0,41.667,53.9Zm-1.993-1.74q-.94.247-1.87.531l6.071-14.745,3.169,12.9A47.651,47.651,0,0,0,39.674,52.161Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernBridgeRoadSymbolIcon);
export default __webpack_public_path__ + "static/media/modern_bridge_road_symbol_icon.119cb4ca7e5c8f191409490f8fa68624.svg";
export { ForwardRef as ReactComponent };